import React, { useState, useEffect } from 'react';
import { Divider, Space, Typography } from 'antd';
import { CheckSquareOutlined } from '@ant-design/icons';

import styled from 'styled-components';

import { phaseTwoWip } from 'components/landlord_app/application_management/common/actions/WipModal';

import { getTodos } from '../api/cotenants';
import TitleWithIcon from '../common/TitleWithIcon';

const { Title, Text, Link } = Typography;

const StyledLink = styled(Link)``;
const StyledSpace = styled(Space)`
  width: '100%';
  margin-left: 12px;
  margin-top: 12px;
`;

const TodoActions = {
  payment: 0,
  notification_preferences: 1,
  insurance: 2,
  autopay_setup: 3,
  elevator_booking: 4,
  move_in_inspection: 5,
  remind_appicants: 6,
  custom: 7,
};

const ApplicationTodos = ({ cotenantId }) => {
  const [todos, setTodos] = useState([]);
  useEffect(() => {
    getTodos(cotenantId).then(({ todos }) => {
      setTodos(todos);
    });
  }, [cotenantId]);

  return (
    <>
      <Divider />
      <Space direction="vertical" style={{ width: '100%' }}>
        <TitleWithIcon icon={<CheckSquareOutlined />} text="To do" />
        <Text>Please complete the following items:</Text>
      </Space>
      <StyledSpace direction="vertical">
        {todos.map((todo) => (
          <StyledLink
            key={todo.text}
            onClick={() => {
              phaseTwoWip(() => {});
            }}
          >
            {todo.text}
          </StyledLink>
        ))}
      </StyledSpace>
    </>
  );
};

export default ApplicationTodos;
